define(['text!./templates/mfp-download-document.html',
        'underscore'],
    /*
        reusable download directive
     */
    (templateStr) => {

        return ['LocaleService',
        
        function (LocaleService) {

            return {
                restrict: 'AE',
                template: templateStr,
                scope: {
                    docId: '=',
                },

                controller: ['$scope', 'httpSettings', '$window',
                    function ($scope, httpSettings, $window) {
                        $scope.serviceName = 'document/quote/quotedocument';
                        $scope.downloadURI = httpSettings.serviceBaseURLs.pc + $scope.serviceName;
                        $scope.documentNotFoundURL = `${$window.location.pathname.substring(0, location.pathname.lastIndexOf('/'))}/QuoteDocumentError` + `-${LocaleService.getCurrentLocale()}`;
                    },
                ],

            };
        },
        
        ];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPDownloadDocument.js